import React, { useState } from 'react';
//import { useQuery } from '@apollo/client'
import PageLayout from '../components/PageLayout';
import PageTitle from '../components/PageTitle';
import DataSource from '../components/DataSource';
import QueryWriter from '../components/QueryWriter';
import TablePreview from '../components/TablePreview';
import EtlRegister from '../components/EtlRegister';
import ChartBuilder from '../components/ChartBuilder';
var ExplorePage = function () {
    var _a = useState(), datasourceId = _a[0], setDatasourceId = _a[1];
    var _b = useState(), query = _b[0], setQuery = _b[1];
    var _c = useState(false), queryLoading = _c[0], setQueryLoading = _c[1];
    var _d = useState(null), rows = _d[0], setRows = _d[1];
    var _e = useState(), destination = _e[0], setDestination = _e[1];
    //const { data, loading } = useQuery(GetDestinationDocument ,{variables:{id: 73}});
    return (React.createElement(PageLayout, null,
        React.createElement(PageTitle, { title: "Explore" }),
        React.createElement(DataSource, { setDatasourceId: setDatasourceId }),
        React.createElement(QueryWriter, { datasourceId: datasourceId !== null && datasourceId !== void 0 ? datasourceId : '1', query: query, setQuery: setQuery, queryLoading: queryLoading, setQueryLoading: setQueryLoading, setRows: setRows }),
        React.createElement(TablePreview, { key: "QueryPreview", loading: queryLoading, title: "Query Result", data: rows, child: React.createElement(EtlRegister, { datasourceId: datasourceId !== null && datasourceId !== void 0 ? datasourceId : '1', query: query, setDestination: setDestination }) }),
        destination ? React.createElement(ChartBuilder, { destinationData: rows, destination: destination }) : null));
};
export default ExplorePage;
